import './NavLogo.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import DefaultLogo from 'components/nav/images/amazon-author-logo.png';
import JapaneseLogo from 'components/nav/images/amazon-author-logo-jp.png';
import I18nStore from 'stores/I18nStore';

class NavLogo extends React.Component {
  static propTypes = {
    forceCenteredLogo: PropTypes.bool,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static localizedLogos = {
    ja_JP: JapaneseLogo,
  };

  render() {
    const { getString } = this.context;
    const className = this.props.forceCenteredLogo ? ' navbar-logo centered-logo' : 'navbar-logo';
    const logo = NavLogo.localizedLogos[I18nStore.getState().currentLocale] || DefaultLogo;
    return (
      <Link className="navbar-brand" to="/">
        <img className={className} src={logo} alt={getString('AA_AmazonAuthor')} />
      </Link>
    );
  }
}

export default NavLogo;
